import {Component, Input} from '@angular/core';

import {OwnProfileResponse} from "@numizmat/services-models/core";

import {
  BlockedUsersComponent
} from "@numizmat/pages/profile-page/components/own-profile/components/profile-settings/components/blocked-users/blocked-users.component";
import {
  DeleteAccountComponent
} from "@numizmat/pages/profile-page/components/own-profile/components/profile-settings/components/delete-account/delete-account.component";
import {
  AccountSettingsComponent
} from "@numizmat/pages/profile-page/components/own-profile/components/profile-settings/components/account-settings/account-settings.component";
import {
  NotificationSettingsComponent
} from "@numizmat/pages/profile-page/components/own-profile/components/profile-settings/components/notification-settings/notification-settings.component";

@Component({
    selector: 'nz-profile-settings',
    imports: [
        BlockedUsersComponent,
        DeleteAccountComponent,
        AccountSettingsComponent,
        NotificationSettingsComponent
    ],
    templateUrl: './profile-settings.component.html',
    styleUrl: './profile-settings.component.scss'
})
export class ProfileSettingsComponent {
  @Input() profile!: OwnProfileResponse;
}
